import { fetchNotStartedPhotoSessions, fetchStartedPhotoSessions } from 'api/photo-session';
import { isProblemSessionRescheduleEnabled } from 'data/feature-flags/problemSessionReschedule';
import {
  FETCH_NOT_STARTED_PHOTO_SESSIONS,
  FETCH_STARTED_PHOTO_SESSIONS,
  PHOTO_SESSIONS_LIST_PAGE_VIEWED_ANALYTICS,
  PHOTO_SESSIONS_LIST_CLICKED_ANALYTICS,
} from './types';

export const fetchNotStartedPhotoSessionsAction = () => ({
  type: FETCH_NOT_STARTED_PHOTO_SESSIONS,
  promise: isProblemSessionRescheduleEnabled()
    .then((includeProblem) => fetchNotStartedPhotoSessions({ includeProblem })),
});

export const fetchStartedPhotoSessionsAction = () => ({
  type: FETCH_STARTED_PHOTO_SESSIONS,
  promise: fetchStartedPhotoSessions(),
});

export const photoSessionsListPageViewedAnalytics = () => ({
  type: PHOTO_SESSIONS_LIST_PAGE_VIEWED_ANALYTICS,
});

export const photoSessionsListClickedAnalytics = (photoSessionId) => ({
  type: PHOTO_SESSIONS_LIST_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
  },
});
